import React, { useEffect, useState } from 'react'
import Contacts from '../../Components/Contacts/Contacts';

const ContactsPage = () => {
    const [data, setData] = useState(null);

    const getData = () => {
    fetch('settings.json'
        , {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        }
    ).then(function(response){
        return response.json();
    })
    .then(function(myJson) {
        console.log(myJson)
        setData(myJson.Components);
    });
    }
    useEffect(() => {
    getData()
    }, [])


    return (
        <div>
        {
            data && <Contacts props={data.Contact}/>
        }            
        </div>
    )
}

export default ContactsPage
